interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "center" | "left";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "center",
}: SectionHeadingProps) {
  return (
    <div
      className={`mb-10 ${
        align === "center" ? "text-center mx-auto max-w-2xl" : "text-left"
      }`}
    >
      <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold">
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl md:text-4xl text-foreground-950">
        {title}
      </h2>
      {desc && (
        <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
          {desc}
        </p>
      )}
    </div>
  );
}